<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center">
        <v-flex xs12 md5 sm8>
          <h3 class="text-center">Diagnostic Kit - <small>{{ diagnostic_kit.name }}</small></h3>
          <v-card flat>
            <v-card-title class="py-1">
              {{ diagnostic_kit.name }}
              <v-spacer></v-spacer>
              <v-btn small v-if="canEdit" title="Edit" @click="goTo('/diagnostic_kits/' + diagnostic_kit.id + '/edit')" text outlined>Edit</v-btn>
            </v-card-title>
            <v-card-text>
              <my-details header="Description">{{ diagnostic_kit.description }}</my-details>
              <my-details header="Model">{{ diagnostic_kit.model }}</my-details>
              <my-details header="Required">
                <v-btn small title="Change status" @click="changeStatus(diagnostic_kit.required)" icon>
                  <v-icon>{{ diagnostic_kit.required ? 'mdi-checkbox-marked-outline' : 'mdi-checkbox-blank-outline' }}</v-icon>
                </v-btn>
              </my-details>
              <my-details header="Created">{{ moment(diagnostic_kit.created_at).fromNow() }}</my-details>
              <my-details>By: <i>{{ diagnostic_kit.user.name }}</i></my-details>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'
  const MyDetails = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/details.vue')

  export default {
    name: 'DiagnosticKitsShow',
    layout,
    props: [
      'diagnostic_kit',
      'canEdit'
    ],
    components: {
      MyDetails,
    },
    metaInfo () {
      return {
        title: 'Diagnostic Kit',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {}
    },
    methods: {
      changeStatus (status) {
        let kit = this.diagnostic_kit
        kit.required = !status
        this.$inertia.put('/diagnostic_kits/' + this.diagnostic_kit.id, kit, {
          onFinish: () => {}
        })
      },
    },
  }
</script>
